<template>
	<div class="card">
		<div class="header">
			<h3>Key Dates</h3>
		</div>
		<div class="item">
			<span class="label">Batched</span>
			<span class="value"> {{ batchedDate }} </span>
		</div>
		<div class="item">
			<span class="label">Credit Pulled</span>
			<span class="value"> {{ creditPulledDate }} </span>
		</div>
		<div class="item">
			<span class="label">Initial Status</span>
			<span class="value"> {{ initialStatusDate }} </span>
		</div>
		<div class="item">
			<span class="label">Final Status</span>
			<span class="value"> {{ finalStatusDate }} </span>
		</div>
	</div>
</template>

<script setup lang="ts">
	withDefaults(defineProps<{
		batchedDate?: string;
		creditPulledDate?: string;
		initialStatusDate?: string;
		finalStatusDate?: string;
	}>(), {
		batchedDate: 'N/A',
		creditPulledDate: 'N/A',
		initialStatusDate: 'N/A',
		finalStatusDate: 'N/A'
	});
</script>

<style scoped src="@/assets/css/card-rizz.css" />
